import React, { useState, useEffect, useRef } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Modal } from 'bootstrap';
import { useNavigate } from "react-router-dom";
import clientHttp from '../../components/ClientHttp';
import { formatDateDB } from '../../components/DateUtil';
import { base64ToBlob } from "../../components/DataConvert";
import Pagination from '../../components/Pagination';

import OrderPaymentList from "./OrderPaymentList";
import { saveAs } from 'file-saver';

export default function OrderPaymentReconcileContent() {
    const currentDate = new Date();
    const [fromDate, setFromDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()));
    const [toDate, setToDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate())); //useState(currentDate);
    const [data, setData] = useState(null);
    const [totalOrderPaid, setTotalOrderPaid] = useState(0);
    const [totalOrderNotPaid, setTotalOrderNotPaid] = useState(0);
    const [totalPaymentPaid, setTotalPaymentPaid] = useState(0);
    const [totalPaymentNotPaid, setTotalPaymentNotPaid] = useState(0);

    const [error, setError] = useState('');
    const [errorClass, setErrorClass] = useState('');
    const [aboNo, setAboNo] = useState('')
    const [orderId, setOrderId] = useState('')
    const [mismatchOrder, setMismatchOrder] = useState('false')

    let navigate = useNavigate()

    const [isSearchLoading, setIsSearchLoading] = useState(false)
    const [isDownloadLoading, setIsDownloadLoading] = useState(false)

    let datePast = parseInt(process.env.REACT_APP_ORDERPAYMENT_DATEPAST)
    console.log('datePast: ' + datePast)
    const [minDate, setMinDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate()));
    const [maxDate, setMaxDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate() + datePast));

    // change page
    const [currentPage, setCurrentPage] = useState(1);
    const [total, setTotal] = useState(0)
    const [pageSize, setPageSize] = useState(10);
    const onPageChange = (page) => {
        setCurrentPage(page);
        console.log('select page: ' + page)
        searchSubmit(page)
    }
    const selectPageSize = (e) => { setPageSize(e.target.value) }
    const changeAboNo = (e) => { setAboNo(e.target.value) }
    const changeOrderId = (e) => { setOrderId(e.target.value) }
    async function changeMismatchOrder(event) {
        console.log('mismatch: ' + event.target.checked)
        if (event.target.checked) setMismatchOrder('true')
        else setMismatchOrder('false')
    }
    const onDateChange = (newDate) => {
        console.log('select from date: ' + newDate)
        setFromDate(newDate)
        setToDate(newDate)
        setMinDate(newDate)
        setMaxDate(new Date(newDate.getFullYear(), newDate.getMonth(), newDate.getDate() + datePast))
    };

    // DatePicker
    const fromDateCalendar = useRef(null)
    const toDateCalendar = useRef(null)
    async function openFromDateCalendar() { fromDateCalendar.current.setFocus(true); }
    async function openToDateCalendar() { toDateCalendar.current.setFocus(true); }

    async function searchSubmit(page) {
        setCurrentPage(page);
        setIsSearchLoading(true)
        let isSuccess = false
        // clear data
        setError('')
        setErrorClass('')
        setData(null)

        console.log('call search api with parameters:' + fromDate, toDate, orderId, aboNo, page, pageSize, mismatchOrder)
        const _fromDate = fromDate.getFullYear() + '-' + (fromDate.getMonth() + 1) + '-' + fromDate.getDate(); // + ' 00:00:00'
        const _toDate = toDate.getFullYear() + '-' + (toDate.getMonth() + 1) + '-' + toDate.getDate(); // + ' 23:59:59'
        const formData = {
            fromDate: _fromDate,
            toDate: _toDate,
            orderId: orderId,
            aboNo: aboNo,
            page: page,
            pageSize: pageSize,
            mismatchOrder: mismatchOrder
        }
        console.log(formData)
        let token = localStorage.getItem('token')
        await clientHttp.post('report/v1/orderpaymentlist', formData, {
            headers: { 'Authorization': 'Bearer ' + token }
        })
            .then(response => {
                console.log('response status: ' + response.status)
                if (response.data.status === 'success') {
                    console.log('display order payment list')
                    setTotal(response.data.total)
                    setData(response.data.data)
                    setTotalOrderPaid(response.data.total_orderpaid)
                    setTotalOrderNotPaid(response.data.total_ordernotpaid)
                    setTotalPaymentPaid(response.data.total_paymentpaid)
                    setTotalPaymentNotPaid(response.data.total_paymentnotpaid)
                    //console.log(response)
                    isSuccess = true
                    setErrorClass('text-black')
                } else {
                    console.log('get order payment list failed: ' + response.data.message)
                    setError(response.data.message)
                    setErrorClass('text-danger')
                }

            }).catch(err => {
                console.log('error: ', err.message)
                if (err.response.status === 401 || err.response.status === 403) {
                    console.log('no authorize, redirect to login page')
                    navigate(process.env.REACT_APP_LOGIN_URI)
                } else {
                    console.log('get order payment list failed: ' + err.message)
                    setError(err.message)
                    setErrorClass('text-danger')
                }
            })

        if (!isSuccess) {
            let errorMessageModal = new Modal('#errorMessageModal')
            errorMessageModal.show()
        }
        setIsSearchLoading(false)
    }

    async function downloadGatewayAPISubmit() {
        console.log('download api order payment list')
        setIsDownloadLoading(true)
        let isSuccess = false
        setError('')
        setErrorClass('')

        //https://of0lieevd9.execute-api.ap-southeast-1.amazonaws.com/uat/s3?key=UAT/Report/202505/${filename}
        const _fromDate = formatDateDB(fromDate)
        const _toDate = formatDateDB(toDate)
        console.log('call download report between date:' + _fromDate + ', ' + _toDate)

        // call api gateway
        let reportApi = process.env.REACT_APP_ORDERPAYMENT_API
        const formData = {
            dateFrom: _fromDate,
            dateTo: _toDate,
            orderId: orderId,
            abo: aboNo
        }

        // Send formData object
        let token = localStorage.getItem('token')
        console.log('call download report with url:' + reportApi)
        await clientHttp.post(reportApi, formData, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
                'Accept': 'application/*'
            },
            responseType: 'json'
            //responseType: 'arraybuffer'
        }).then(response => {
            console.log(response)
            const filename = response.data.headers.filename;
            console.log('receive report file: ' + filename)

            isSuccess = true;
            const blob = base64ToBlob(response.data.body, "application/vnd.ms-excel");
            let url = window.URL.createObjectURL(blob);
            saveAs(url, filename);

            isSuccess = true;
        }).catch(error => {
            console.log(error)

            if (error.response.status === 401 || error.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('get download report file failed: ' + error.message)
                setError('Failed to export file')
            }
        })

        if (!isSuccess) {
            let errorMessageModal = new Modal('#errorMessageModal')
            errorMessageModal.show()
        }
        //await new Promise( res => setTimeout(res, 1000) );
        setIsDownloadLoading(false)
    }
    async function downloadAPISubmit() {
        console.log('download api order payment list')
        setIsDownloadLoading(true)
        let isSuccess = false
        setError('')
        setErrorClass('')

        const _fromDate = formatDateDB(fromDate)
        const _toDate = formatDateDB(toDate)
        console.log('call download report between date:' + _fromDate + ', ' + _toDate)

        // call backend api
        let reportApi = 'report/v1/download_orderpaymentlist'
        const formData = {
            fromDate: _fromDate,
            toDate: _toDate,
            orderId: orderId,
            aboNo: aboNo
        }

        // Send formData object
        let token = localStorage.getItem('token')
        console.log('call download report with url:' + reportApi)
        await clientHttp.post(reportApi, formData, {
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
                'Accept': 'application/*'
            },
            responseType: 'json'
            //responseType: 'arraybuffer'
        }).then(response => {
            console.log(response)
            let filename = response.headers["content-disposition"].split("filename=")[1];
            console.log('receive report file: ' + filename)

            const blob = base64ToBlob(response.data, "application/vnd.ms-excel");
            let url = window.URL.createObjectURL(blob);
            saveAs(url, filename);

            isSuccess = true;
        }).catch(error => {
            console.log(error)

            if (error.response.status === 401 || error.response.status === 403) {
                console.log('no authorize, redirect to login page')
                navigate(process.env.REACT_APP_LOGIN_URI)
            } else {
                console.log('get download report file failed: ' + error.message)
                setError('Failed to export file')
            }
        })

        if (!isSuccess) {
            let errorMessageModal = new Modal('#errorMessageModal')
            errorMessageModal.show()
        }
        //await new Promise( res => setTimeout(res, 1000) );
        setIsDownloadLoading(false)
    }

    // useEffect(() => {
    //     // first enter then call search with current month
    //     searchSubmit(1)
    // }, [])

    return (
        <>
            <div className="page-header">
            </div>
            <div className="row">
                <div className="col-md-12">
                    {/* start form */}
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group ">
                                            <span className="input-group-text">From Date:</span>
                                            <DatePicker className="form-control" ref={fromDateCalendar} selected={fromDate} onChange={onDateChange} dateFormat="dd/MM/yyyy" />
                                            <span className="input-group-text" onClick={openFromDateCalendar.bind(this)}><i className="bi bi-calendar-date"></i></span>

                                            <span className="input-group-text ms-3">To Date:</span>
                                            <DatePicker className="form-control" ref={toDateCalendar} selected={toDate} minDate={minDate} maxDate={maxDate} onChange={(date) => setToDate(date)} dateFormat="dd/MM/yyyy" />
                                            <span className="input-group-text" onClick={openToDateCalendar.bind(this)}><i className="bi bi-calendar-date"></i></span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-1 col-md-1 col-sm-1">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <select className="form-select" defaultValue={pageSize} onChange={selectPageSize}>
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                                <option value="500">500</option>
                                                <option value="1000">1000</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-5 col-md-5 col-sm-5 col-xs-12">
                                    <div className="form-group">
                                        {isSearchLoading ?
                                            <button className="btn btn-black btn-border btn-primary" style={{ "width": "120px" }} type="button">
                                                <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                <span role="status" className="ms-3">Loading...</span>
                                            </button>
                                            :
                                            <button type="button" className="btn btn-primary" style={{ "width": "120px" }} onClick={searchSubmit.bind(this, 1)}>
                                                <i className="bi bi-search me-2"></i> Search
                                            </button>
                                        }
                                        {isDownloadLoading ?
                                            <button className="btn btn-black btn-border ms-3" style={{ "width": "120px" }} type="button">
                                                <span className="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                                <span role="status" className="ms-3">Loading...</span>
                                            </button>
                                            :
                                            <button type="button" className="btn btn-black btn-border ms-3" style={{ "width": "140px" }} onClick={downloadAPISubmit.bind(this)}>
                                                Export to Excel <i className="bi bi-download ms-2"></i>
                                            </button>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group ">
                                            <span className="input-group-text">Order Id:</span>
                                            <input type="text" className="form-control" placeholder="Enter Order Id" onChange={changeOrderId} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group ">
                                            <span className="input-group-text">ABO No:</span>
                                            <input type="text" className="form-control" placeholder="Enter ABO No." onChange={changeAboNo} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-2 col-md-2 col-sm-2 col-xs-12">
                                    <div className="form-group">
                                        <div className="input-group">
                                            <input type="checkbox" value="true" className="captureOrderId" onChange={e => { changeMismatchOrder(e) }} />
                                            <span className='ms-2'>Only Mismatch Orders</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                    <div className="form-group">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* end form */}
                </div>
            </div>

            <div className="row">
                <div className="col-md-12">
                    <OrderPaymentList fromDate={fromDate} toDate={toDate} data={data}
                        totalOrderPaid={totalOrderPaid} totalOrderNotPaid={totalOrderNotPaid}
                        totalPaymentPaid={totalPaymentPaid} totalPaymentNotPaid={totalPaymentNotPaid} />
                </div>
            </div>

            <Pagination total={total} pageSize={pageSize} currentPage={currentPage} onPageChange={onPageChange} />

            <div className='row'>
                <div className='col-md-12'>
                    <div className="modal fade" id="errorMessageModal" tabIndex="-1" >
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-body">
                                    <p className={errorClass}>{error}</p>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}